import React, { Component } from 'react';
import { Link, withRouter } from "react-router-dom";
import '../css/app.css';
import '../css/order.css';
import Header from '../component/header';
import Footer from '../component/footer';
import OrderForm from '../component/orderForm';

class Order extends React.Component {
  constructor(props) {
    super(props)
  }

    
  render() {
    const {history} = this.props
    console.log("history:", history)
    return (
      <div className="order-frame">
        <Header context={(this.props.context !== undefined) ? this.props.context: "" }/>
        <OrderForm context={(this.props.context !== undefined) ? this.props.context: "" }/>
        <Footer context={(this.props.context !== undefined) ? this.props.context: "" }/>
      </div>
    );
  }
}

export default withRouter(Order);


// WEBPACK FOOTER //
// ./src/pages/order.js